import {
    MICROTREND,
    MACROTREND,
    TRENDRADAR,
    WORKSPACE,
    INNOVATION_FIELD,
    INNOVATION_PROJECT
} from '@/model/export/types'

import {
    PDF,
    PPTX,
    XLSX
} from '@/model/export/formats'

export default {
    title: {
        [INNOVATION_FIELD]: 'Export innovation field',
        [INNOVATION_PROJECT]: 'Export innovation project',
        [MICROTREND]: 'Export micro-trend',
        [MACROTREND]: 'Export macro-trend',
        [TRENDRADAR]: 'Export trend radar',
        [WORKSPACE]: 'Export work space'
    },
    type: {
        [INNOVATION_FIELD]: 'Innovation field',
        [INNOVATION_PROJECT]: 'Innovation project',
        [MICROTREND]: 'Micro-trend',
        [MACROTREND]: 'Macro-trend',
        [TRENDRADAR]: 'Trend radar',
        [WORKSPACE]: 'Work space'
    },
    format: {
        title: 'Please select your export format',
        running: 'Your export is being prepared',
        error: 'An error occured!',
        [PPTX]: 'PowerPoint',
        [PDF]: 'PDF',
        [XLSX]: 'Excel'
    },
    template: {
        title: 'Please select an export template'
    },
    actions: {
        export: 'Export',
        download: 'Download'
    }
}
